<template>
    <div>
        <el-form ref="form" :model="form">
            <table class="t1">
                <colgroup>
                    <col width="124">
                    <col width="124">
                    <col width="62">
                    <col width="62">
                    <col width="124">
                    <col width="124">
                    <col width="62">
                    <col width="62">
                    <col width="124">
                    <col width="124">
                    <col width="124">
                </colgroup>
                <tbody>
                <tr>
                    <td colspan="11" style="font-size: 21px;font-weight: bold;font-family: 宋体;"></td>
                </tr>
                <tr>
                    <td colspan="11" style="font-size: 21px;font-weight: bold;font-family: 宋体;">听课记录表</td>
                </tr>
                <tr>
                    <td colspan="11">{{ getSemesterName() }}</td>
                </tr>
                <tr class="r1">
                    <td class="c1">授课教师</td>
                    <td class="c1" colspan="2">
                        <el-form-item label="" prop="teaCode" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="form.teaCode" placeholder="请选择" style="width: 150px;"
                                       @change="teaChange" filterable clearable>
                                <el-option v-for="(item, index) in comboOption.tea" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td class="c1" colspan="2">教师所在系部</td>
                    <td class="c1" colspan="2">{{ form.deptName }}</td>
                    <td class="c1" colspan="2">听课日期</td>
                    <td class="c1" colspan="2">
                        <el-form-item label="" prop="date" :rules="[{required: true, message: ' '}]">
                            <el-date-picker v-model="form.date" type="date" placeholder="选择日期" style="width: 100%;"
                                            value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </td>
                </tr>
                <tr class="r1">
                    <td class="c2">授课班级</td>
                    <td class="c2" colspan="2">{{ form.className }}</td>
                    <td class="c2" colspan="2">授课地点</td>
                    <td class="c2" colspan="2">
                        <el-form-item label="" prop="site" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="form.site" filterable placeholder="请选择" style="width: 150px;" clearable>
                                <el-option v-for="(item, index) in comboOption.site" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td class="c2" colspan="2">听课节次</td>
                    <td class="c2" colspan="2">
                        <el-form-item label="" prop="time" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="form.time" multiple :multiple-limit="3" placeholder="请选择" clearable
                                       style="width: 100%">
                                <el-option v-for="(item, index) in comboOption.time" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                </tr>
                <tr class="r1">
                    <td class="c2">课程名称</td>
                    <td class="c2" colspan="4">
                        <el-form-item label="" prop="courseCode" :rules="[{required: true, message: ' '}]">
                            <el-select v-model="form.courseCode" placeholder="请选择" style="width: 100%;"
                                       @change="courseChange" clearable>
                                <el-option v-for="(item, index) in comboOption.course" :key="item.comboValue"
                                           :value="item.comboValue" :label="item.comboName">
                                    <div slot>{{ item.className + " - (" + item.comboName + ")" }}</div>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td class="c2" colspan="2">课题</td>
                    <td class="c2" colspan="4">
                        <el-form-item label="" prop="kt" :rules="[{required: true, message: ' '}]">
                            <el-input v-model="form.kt" maxlength="500">
                            </el-input>
                        </el-form-item>
                    </td>
                </tr>
                <tr class="r1">
                    <td class="c2" rowspan="4">到课情况</td>
                    <td class="c2" colspan="4">教师情况</td>
                    <td class="c2" colspan="6">学生情况</td>
                </tr>

                <tr class="r1">
                    <td class="c2" rowspan="2">按时上课<br>（&radic;）</td>
                    <td class="c3" colspan="2">迟到<br>（分钟）</td>
                    <td class="c1" rowspan="2">提前下课<br>（分钟）</td>
                    <td class="c1" rowspan="2">应到<br>人数</td>
                    <td class="c1" colspan="2" rowspan="2">实到<br>人数</td>
                    <td class="c1" rowspan="2">迟到<br>人数</td>
                    <td class="c4">迟到最长<br>（分钟）</td>
                    <td class="c4">早退<br>人数</td>
                </tr>
                <tr class="r1" style="height: 0">
                    <td class="c5" colspan="2"></td>
                    <td class="c2"></td>
                    <td class="c2"></td>
                </tr>
                <tr class="r1">
                    <td class="c2">
                        <el-form-item label="" prop="assk">
                            <el-checkbox v-model="form.assk"></el-checkbox>
                        </el-form-item>
                    </td>
                    <td class="c2" colspan="2">
                        <el-form-item label="" prop="cd" :rules="[{required: true, message: ' '}]">
                            <el-input-number v-model="form.cd" style="width: 100px;" :min="0" :controls="false"/>
                        </el-form-item>
                    </td>
                    <td class="c2">
                        <el-form-item label="" prop="tqxk" :rules="[{required: true, message: ' '}]">
                            <el-input-number v-model="form.tqxk" style="width: 100px;" :min="0" :controls="false"/>
                        </el-form-item>
                    </td>
                    <td class="c2">{{ form.ydxss }}</td>
                    <td class="c2" colspan="2">
                        <el-form-item label="" prop="sdrs" :rules="[{required: true, message: ' '}]">
                            <el-input-number v-model="form.sdrs" style="width: 100px;" :min="0" :controls="false"/>
                        </el-form-item>
                    </td>
                    <td class="c2">
                        <el-form-item label="" prop="cdrs" :rules="[{required: true, message: ' '}]">
                            <el-input-number v-model="form.cdrs" style="width: 100px;" :min="0" :controls="false"/>
                        </el-form-item>
                    </td>
                    <td class="c2">
                        <el-form-item label="" prop="cdrs" :rules="[{required: true, message: ' '}]">
                            <el-input-number v-model="form.cdzc" style="width: 100px;" :min="0" :controls="false"/>
                        </el-form-item>
                    </td>
                    <td class="c2">
                        <el-form-item label="" prop="ztrs" :rules="[{required: true, message: ' '}]">
                            <el-input-number v-model="form.ztrs" style="width: 100px;" :min="0" :controls="false"/>
                        </el-form-item>
                    </td>
                </tr>
                <tr class="r2">
                    <td class="c6" colspan="11">授课过程记录</td>
                </tr>
                <tr class="r1">
                    <td class="c10" colspan="11">
                        <el-form-item label="" prop="skgcjl" :rules="[{required: true, message: ' '}]">
                            <el-input type="textarea" :rows="15" v-model="form.skgcjl" maxlength="500" show-word-limit/>
                        </el-form-item>
                    </td>
                </tr>
                <tr class="r1">
                    <td class="c8" colspan="11">教学建议</td>
                </tr>
                <tr class="r1">
                    <td class="c10" colspan="11">
                        <el-form-item label="" prop="jxjy" :rules="[{required: true, message: ' '}]">
                            <el-input type="textarea" :rows="15" v-model="form.jxjy" maxlength="500" show-word-limit/>
                        </el-form-item>
                    </td>
                </tr>
                <tr class="r1">
                    <td class="c7" colspan="11">
                        <span>评价等级（勾选）：</span>
                        <span style="float: right">
                            <el-form-item prop="pjdj" :rules="[{required: true, message: '请选择评价登记'}]">
                            <el-radio-group v-model="form.pjdj">
                            <el-radio label="A">优秀</el-radio>
                        <el-radio label="B">良好</el-radio>
                        <el-radio label="C">中等</el-radio>
                        <el-radio label="D">合格</el-radio>
                        <el-radio label="E">不合格</el-radio>
                        </el-radio-group>
                        </el-form-item>
                        </span>
                    </td>

                </tr>
                <tr class="r1">
                    <td class="c9"></td>
                </tr>
                </tbody>
            </table>
        </el-form>

        <table class="t1">
            <colgroup>
                <col width="70">
                <col width="1046">
            </colgroup>
            <tbody>
            <tr class="r1">
                <td class="c1" colspan="2" style="font-weight: bold;font-family: 宋体;">公共基础课程参考指标</td>
            </tr>
            <tr class="r1">
                <td class="c1">目标<br>与<br>学情</td>
                <td class="c11">1.符合新时代对技术技能人才培养新要求，落实教育部颁布的公共基础课程教学标准有关要求，紧扣学校专业人才培养方案和课程教学安排，夯实学生科学文化基础，着力培养学生人文素养、职业素养、信息素养，培养学生工匠精神、科学精神、创新精神和终身学习能力。<br>2.教学目标表述明确、相互关联，重点突出、可评可测。<br>3.客观分析学生知识基础、认知能力、学习特点、专业特性等，详实反映学生整体情况与个体差异，准确预判教学难点。</td>
            </tr>
            <tr class="r1">
                <td class="c1">内容<br>与<br>策略</td>
                <td class="c11">1.思政课程按照“八个相统一”要求扎实推进创优建设；其他课程注重落实课程思政要求，结合课程特点挖掘思政元素，有机融入课程教学，达到润物无声的育人效果。<br>2.教学内容落实公共基础课程课标，突出思想性、科学性、基础性、职业性和时代性，有效支撑教学目标的实现，内容选择科学严谨、容量适度，安排合理、衔接有序、结构清晰，符合层次定位。<br>3.教材选用、使用符合《职业院校教材管理办法》等文件规定和要求，配套提供丰富、优质学习资源；教案完整、规范、简明、真实。<br>4.教学设计科学合理，教学过程系统优化，流程环节构思得当，技术应用预想合理，方法手段设计恰当，评价考核科学有效。</td>
            </tr>
            <tr class="r1">
                <td class="c1">实施<br>与<br>成效</td>
                <td class="c11">1.教育思想和教学理念先进，遵循学生认知规律，反映日常教学实际。<br>2.按照授课计划实施教学，关注重点、难点的解决，能够针对学习反馈及时调整教学，突出学生中心，实行因材施教。<br>3.教学环境真实，满足教学需要，教学活动开展有序，教学互动深入有效，教学气氛生动活泼，学生学有所得。<br>4.关注教与学行为数据采集，针对目标要求开展考核与评价。<br>5.创新教学方式方法，合理运用前沿信息技术、数字化教学资源、设施设备改造传统教学，提升学习效果、提高教学与管理成效。</td>
            </tr>
            <tr class="r1">
                <td class="c1">教学<br>素养</td>
                <td class="c11">1.展现新时代职业院校教师良好的师德师风、教学能力和信息素养。<br>2.教师课堂教学态度认真、严谨规范、表述清晰、亲和力强、仪态自然。<br>3.教学研究深入，学术功底扎实。</td>
            </tr>
            <tr class="r1">
                <td class="c1">特色<br>创新</td>
                <td class="c11">1.在落实立德树人、文化素养提升、课程思政建设等方面有行之有效的做法，能够调动学生全面深度参与，给学生深刻的学习体验。<br>2.在落实国家教学标准、推进“三教”改革、运用信息技术等方面有特色、有创新。<br>3.具有较大借鉴和推广价值。</td>
            </tr>
            </tbody>
        </table>


    </div>
</template>

<script>
import {confirmMsg, showNotify} from "utils/message";

export default {
    props: ['userCode', 'userName', 'semesterCode', 'type', 'semesterCombo'],
    data() {
        return {
            form: {
                semesterCode: '',
                teaCode: '',
                deptName: '',
                deptCode: '',
                date: '',
                time: [],
                className: '',
                classCode: '',
                courseCode: '',
                courseName: '',
                ydxss: '',
                assk: true,
                cd: 0,
                tqxk: 0,
                sdrs: 0,
                cdrs: 0,
                cdzc: 0,
                ztrs: 0,
                kt: '',
                skgcjl: '',
                jxjy: '',
                pjdj: '',
                site:''
            },
            comboOption: {
                tea: [],
                course: [],
                time: [],
                site: []
            },
            loadingMask:null
        };

    },
    mounted() {
        this.tkTeaCombo();
        this.tkJcInfo();
        this.tkTkddCombo()
    },
    methods: {
        submit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    confirmMsg('提交后无法修改,是否确定提交?').then(() => {
                        this.showLoadingMask('提交中，请稍候...')

                        for (var i = 0; i < this.comboOption.tea.length; i++) {
                            if (this.comboOption.tea[i].comboValue === this.form.teaCode) {
                                this.form.teaName = this.comboOption.tea[i].comboName
                                break;
                            }
                        }

                        for (var i = 0; i < this.comboOption.course.length; i++) {
                            if (this.comboOption.course[i].comboValue === this.form.courseCode) {
                                this.form.courseName = this.comboOption.course[i].courseName
                                break;
                            }
                        }

                        for (var i = 0; i < this.comboOption.course.length; i++) {
                            if (this.comboOption.course[i].comboValue === this.form.courseCode) {
                                this.form.courseCode = this.comboOption.course[i].otherInfo
                                break;
                            }
                        }

                        const paramMap = {
                            'teaCode': this.form.teaCode,
                            'teaName': this.form.teaName,
                            'deptCode': this.form.deptCode,
                            'deptName': this.form.deptName,
                            'date': this.form.date,
                            'time': this.form.time.join(','),
                            'className': this.form.className,
                            'classCode': this.form.classCode,
                            'courseCode': this.form.courseCode,
                            'courseName': this.form.courseName,
                            'ydxss': this.form.ydxss,
                            'assk': this.form.assk === true ? "1" : "0",
                            'cd': this.form.cd,
                            'tqxk': this.form.tqxk,
                            'sdrs': this.form.sdrs,
                            'cdrs': this.form.cdrs,
                            'ztrs': this.form.ztrs,
                            'cdzc': this.form.cdzc,
                            'kt': this.form.kt,
                            'skgcjl': this.form.skgcjl,
                            'jxjy': this.form.jxjy,
                            'pjdj': this.form.pjdj,
                            'site': this.form.site,
                            'CJR': this.userCode,
                            'type': this.type,
                            'semesterCode': this.semesterCode,
                        }

                        this.$api.evaluateManage.questionnaireServer.subTkGgForm({
                            data: paramMap
                        })
                            .then((res) => {
                                let state = res.data.data;
                                switch (state) {
                                    case 'success':
                                        // showNotify('成功', '提交成功', 'success', 1500);
                                        location.reload();
                                        break;
                                    default:
                                        this.closeLoadingMask()
                                        showNotify('错误', '提交失败', 'error', 3000);
                                        break;
                                }
                            }).catch((err) => {
                            this.closeLoadingMask()
                            console.log(err);
                        });
                    });

                } else {
                    return false;
                }
            });
        },
        courseChange(str) {
            this.comboOption.course.forEach(item => {
                if (item.comboValue === str) {
                    this.form.className = item.className;
                    this.form.classCode = item.classCode;
                    this.tkChangeTkbj()
                    this.loadClassSite()
                    return;
                }
            })
        },
        loadClassSite(){
            this.$api.evaluateManage.questionnaireServer.loadClassSite({
                data: this.form.classCode
            })
                .then((res) => {
                    this.form.site = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        tkChangeTkbj() {
            const paramMap = {
                'tkbjCode': this.form.classCode,
                'semesterCode': this.semesterCode,
                'skjhmxbh': this.form.courseCode
            }
            this.$api.evaluateManage.questionnaireServer.tkYdxss({
                data: paramMap
            })
                .then((res) => {
                    this.form.ydxss = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        tkJcInfo() {
            this.$api.evaluateManage.questionnaireServer.tkJcInfo({
                data: this.semesterCode
            })
                .then((res) => {
                    this.comboOption.time = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        teaChange() {
            this.comboOption.course = [];
            this.form.courseName = "";
            const paramMap = {
                'teaCode': this.form.teaCode,
                'semesterCode': this.semesterCode,
            }
            if (this.form.teaCode !== "") {
                this.courseCombo(paramMap);
                this.tkSzxb(paramMap)
            }
        },
        courseCombo(paramMap) {
            this.$api.evaluateManage.questionnaireServer.tkGgCourseCombo({
                data: paramMap
            })
                .then((res) => {
                    this.comboOption.course = res.data.data;
                }).catch((err) => {
                console.log(err);
            });
        },
        tkTeaCombo() {
            this.$api.evaluateManage.questionnaireServer.tkTeaCombo({data:this.semesterCode})
                .then((res) => {
                    this.comboOption.tea = res.data.data;
                }).catch((err) => {
                console.log(err);
            });
        },
        //填充教师所在系部
        tkSzxb(paramMap) {
            this.$api.evaluateManage.questionnaireServer.tkSzxb({
                data: paramMap
            })
                .then((res) => {
                    this.form.deptName = res.data.data.comboName;
                    this.form.deptCode = res.data.data.comboValue;
                }).catch((err) => {
                console.log(err);
            });
        },
        getSemesterName() {
            let ind = this.semesterCombo.findIndex(item => {
                return item.comboValue == this.semesterCode
            })
            return this.semesterCombo[ind].comboName
        },
        tkTkddCombo() {
            this.$api.evaluateManage.questionnaireServer.tkTkddCombo({})
                .then((res) => {
                    this.comboOption.site = res.data.data
                }).catch((err) => {
                console.log(err);
            });
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
    }
}
</script>


<style scoped>
.b1 {
    white-space-collapsing: preserve;
}

.t1 {
    margin: auto;
    border-collapse: collapse;
    border-spacing: 0;
}

.r1 {
    height: 15.75pt;
}

.r2 {
    height: 14.25pt;
}

.r3 {
    height: 15.0pt;
}

.c1 {
    white-space: pre-wrap;
    text-align: center;
    border-top: thin solid black;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c2 {
    white-space: pre-wrap;
    text-align: center;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c3 {
    white-space: pre-wrap;
    text-align: center;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c4 {
    white-space: pre-wrap;
    text-align: center;
    border-top: thin solid black;
    border-right: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c5 {
    white-space: pre-wrap;
    text-align: center;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c6 {
    white-space: pre-wrap;
    background-color: white;
    border-left: thin solid black;
    border-right: thin solid black;
    border-bottom: thin solid black;
    font-weight: bold;
    color: black;
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
}

.c7 {
    white-space: pre-wrap;
    background-color: white;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
}

.c8 {
    white-space: pre-wrap;
    background-color: white;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    font-weight: bold;
    color: black;
    font-size: 16px;
    text-align: left;
    padding-left: 10px;
}

.c9 {
    white-space: pre-wrap;
    text-align: center;
    color: black;
    font-size: 16px;
}

.c10 {
    white-space: pre-wrap;
    background-color: white;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
}

.c11 {
    white-space: pre-wrap;
    text-align: left;
    border-top: thin solid black;
    border-right: thin solid black;
    border-bottom: thin solid black;
    border-left: thin solid black;
    color: black;
    font-size: 16px;
    padding-top: 20px;
    padding-bottom: 20px;

}
</style>



// WEBPACK FOOTER //
// tkGgEvaluate.vue?5e8eeae0